module.exports = __webpack_public_path__ + "img/the-love-songs-of-web-du-bois.f3e365a1.png";